"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var d3_format_1 = require("d3-format");

var vega_embed_1 = __importDefault(require("vega-embed"));

var dom_1 = require("../util/dom");

var math_1 = require("../util/math");

var table_1 = require("./table");

var defaultOpts = {
  maxBins: 12,
  fontSize: 11
};

function histogram(container, data) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var values, options, embedOpts, histogramContainer, statsContainer, stats, filtered, i, val, histogramSpec;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            values = prepareData(data);
            options = Object.assign({}, defaultOpts, opts);
            embedOpts = {
              actions: false,
              mode: 'vega-lite',
              defaultStyle: false
            };
            histogramContainer = dom_1.subSurface(container, 'histogram');

            if (opts.stats !== false) {
              statsContainer = dom_1.subSurface(container, 'stats', {
                prepend: true
              });

              if (opts.stats) {
                stats = opts.stats;
              } else {
                stats = math_1.arrayStats(values.map(function (x) {
                  return x.value;
                }));
              }

              renderStats(stats, statsContainer, {
                fontSize: options.fontSize
              });
            }

            filtered = [];

            for (i = 0; i < values.length; i++) {
              val = values[i].value;

              if (val != null && isFinite(val)) {
                filtered.push(values[i]);
              }
            }

            histogramSpec = {
              'width': options.width || histogramContainer.clientWidth,
              'height': options.height || histogramContainer.clientHeight,
              'padding': 0,
              'autosize': {
                'type': 'fit',
                'contains': 'padding',
                'resize': true
              },
              'data': {
                'values': filtered
              },
              'mark': 'bar',
              'config': {
                'axis': {
                  'labelFontSize': options.fontSize,
                  'titleFontSize': options.fontSize
                },
                'text': {
                  'fontSize': options.fontSize
                },
                'legend': {
                  'labelFontSize': options.fontSize,
                  'titleFontSize': options.fontSize
                }
              },
              'encoding': {
                'x': {
                  'bin': {
                    'maxbins': options.maxBins
                  },
                  'field': 'value',
                  'type': 'quantitative'
                },
                'y': {
                  'aggregate': 'count',
                  'type': 'quantitative'
                },
                'color': {
                  'value': '#001B44'
                }
              }
            };
            return _context.abrupt("return", vega_embed_1.default(histogramContainer, histogramSpec, embedOpts));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.histogram = histogram;

function renderStats(stats, container, opts) {
  var format = d3_format_1.format(',.4~f');
  var pctFormat = d3_format_1.format('.4~p');
  var headers = [];
  var vals = [];

  if (stats.numVals != null) {
    headers.push('Num Vals');
    vals.push(format(stats.numVals));
  }

  if (stats.min != null) {
    headers.push('Min');
    vals.push(format(stats.min));
  }

  if (stats.max != null) {
    headers.push('Max');
    vals.push(format(stats.max));
  }

  if (stats.numZeros != null) {
    headers.push('# Zeros');
    var zeroPct = '';

    if (stats.numVals) {
      zeroPct = stats.numZeros > 0 ? "(".concat(pctFormat(stats.numZeros / stats.numVals), ")") : '';
    }

    vals.push("".concat(format(stats.numZeros), " ").concat(zeroPct));
  }

  if (stats.numNans != null) {
    headers.push('# NaNs');
    var nanPct = '';

    if (stats.numVals) {
      nanPct = stats.numNans > 0 ? "(".concat(pctFormat(stats.numNans / stats.numVals), ")") : '';
    }

    vals.push("".concat(format(stats.numNans), " ").concat(nanPct));
  }

  if (stats.numInfs != null) {
    headers.push('# Infinity');
    var infPct = '';

    if (stats.numVals) {
      infPct = stats.numInfs > 0 ? "(".concat(pctFormat(stats.numInfs / stats.numVals), ")") : '';
    }

    vals.push("".concat(format(stats.numInfs), " ").concat(infPct));
  }

  table_1.table(container, {
    headers: headers,
    values: [vals]
  }, opts);
}

function prepareData(data) {
  if (data.length == null) {
    throw new Error('input data must be an array');
  }

  if (data.length === 0) {
    return [];
  } else if (typeof data[0] === 'object') {
    if (data[0].value == null) {
      throw new Error('input data must have a value field');
    } else {
      return data;
    }
  } else {
    var ret = Array(data.length);

    for (var i = 0; i < data.length; i++) {
      ret[i] = {
        value: data[i]
      };
    }

    return ret;
  }
}